// npm i axios --save-dev
//npm install qs
import axios from 'axios'
import qs from 'qs'

axios.tokenFlag = true;
let _this = this;

/***************************调试环境*********************************/
// var hosturl = 'http://frp.yuecin.com:8090/gxdyj_ant';
// export const getsposturl = 'http://frp.yuecin.com:8090/gxdyj_ant'; //登录行为验证地址
// export const posturl = 'http://frp.yuecin.com:8090/gxdyj_ant/public/uploadList'; //上传图片
// export const posturls = 'http://frp.yuecin.com:8090/gxdyj_ant/public/uploadList?isCompression=0'; //上传图片isCompression=0
// export const globelurl = 'http://testdfs.yuecin.com'; //图片地址
// export const uploadVRurl = 'http://192.168.50.26:8098/gxdpano/sys/upload/uploadList'; //vr上传图片地址
// export const frontendUrl = 'http://yue.gxddata.net/yuejuTest/index.html#/'; //前台地址
// export const previewVrUrl = 'http://192.168.50.26:9696'; //vr预览和编辑host
/*************************测试环境***********************************/
// var hosturl = 'http://localhost:8011/gxdyj_ant';
// export const getsposturl = 'http://localhost:8011/gxdyj_ant'; //登录行为验证地址
// export const posturl = 'http://localhost:8011/gxdyj_ant/public/uploadList'; //上传图片
// export const posturls = 'http://localhost:8011/gxdyj_ant/public/uploadList?isCompression=0'; //上传图片isCompression=0
// export const globelurl = 'http://testdfs.yuecin.com'; //图片地址
// export const uploadVRurl = 'http://192.168.50.26:8098/gxdpano/sys/upload/uploadList'; //vr上传图片地址
// export const frontendUrl = 'http://yue.gxddata.net/yuejuTest/index.html#/'; //前台地址
// export const previewVrUrl = 'http://192.168.50.26:9696'; //vr预览和编辑host

/*************************演示环境***********************************/
// var hosturl = 'http://test.yuecin.com/gxdyj_ant';
// export const getsposturl = 'http://test.yuecin.com/gxdyj_ant'; //登录行为验证地址
// export const posturl = 'http://test.yuecin.com/gxdyj_ant/public/uploadList'; //上传图片
// export const posturls = 'http://test.yuecin.com/gxdyj_ant/public/uploadList?isCompression=0'; //上传图片isCompression=0
// export const globelurl = 'http://testdfs.yuecin.com'; //图片地址
// export const uploadVRurl = 'http://192.168.50.26:8098/gxdpano/sys/upload/uploadList'; //vr上传图片地址
// export const frontendUrl = 'http://yue.gxddata.net/yuejuTest/index.html#/'; //前台地址
// export const previewVrUrl = 'http://192.168.50.26:9696'; //vr预览和编辑host

/*************************正式环境***********************************/
// var hosturl = 'https://www.househrb.com/broker';
// export const getsposturl = 'https://www.househrb.com/broker'; //登录行为验证地址
// export const posturl = 'https://www.househrb.com/broker/public/uploadList'; //上传图片
// export const posturls = 'https://www.househrb.com/broker/public/uploadList?isCompression=0'; //上传图片isCompression=0
// export const globelurl = 'https://www.househrb.com'; //图片地址
// export const uploadVRurl = 'http://192.168.50.26:8098/gxdpano/sys/upload/uploadList'; //vr上传图片地址
// export const frontendUrl = 'http://yue.gxddata.net/yuejuTest/index.html#/'; //前台地址
// export const previewVrUrl = 'http://192.168.50.26:9696'; //vr预览和编辑host

/*************************最终版生产环境***********************************/  


// ！！！！！！！！！！！！！！！！！！！！！！！！ 如果添加了新的页面--发布的时候要在线上的数据库添加新页面路径
var hosturl = 'https://bingyi8.com/gxdyj_ant';
export const getsposturl = 'https://bingyi8.com/gxdyj_ant'; //登录行为验证地址
export const posturl = 'https://bingyi8.com/gxdyj_ant/public/uploadList'; //上传图片
export const globelurl = 'https://bingyi8.com'; //图片地址

// 添加请求拦截器
axios.interceptors.request.use(function (d) { // 在发送请求之前做些什么
    if (d.method == 'get') { //get 方法
        // d.params.t = new Date().getTime();
    } else if (d.method == 'post') {}
    return d;
}, function (error) { // 对请求错误做些什么
    return Promise.reject(error);
});

function _logout() {
    if (axios.tokenFlag) {
        sessionStorage.clear();
        axios.tokenFlag = false
        $vInstance.$Message.error('您的账号已在其它设备登录，请您重新登录!');
        $vInstance.$router.replace('/');
        setTimeout(() => {
            axios.tokenFlag = true;
        }, 10000);
    }
}
axios.interceptors.response.use(response => { // 对响应数据做点什么（请求响应后）
    if (response.data.message == "登录状态已失效，请重新登录!") {
        _logout()
    }
    return response;


}, function (error) { // 对响应错误做点什么
    if (error.response.data.message == "登录状态已失效，请重新登录!") {
        _logout()
    }
    return Promise.reject(error);
});

export const axiosget = function (url, data) { //axios get请求
    var header = {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Access-Token': sessionStorage.token ? sessionStorage.token : ''
    }
    //请求的配置的对象参数
    var axiosObj = {
        method: 'get',
        url: hosturl + url,
        timeout: 30000,
        headers: header,
        params: data
    }
    return axios(axiosObj)
}

export const axiosgetExcel = function (url, data) { //axios get请求导出excel
    var header = {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Access-Token': sessionStorage.token ? sessionStorage.token : ''
    }
    //请求的配置的对象参数
    var axiosObj = {
        method: 'get',
        url: hosturl + url,
        timeout: 30000,
        headers: header,
        params: data,
        responseType: "arraybuffer"
    }

    return axios(axiosObj)
}

export const axiosgetDownload = function (url, data) { //axios get请求
    var header = {
        'X-Access-Token': sessionStorage.token ? sessionStorage.token : '',
        'Content-Disposition': 'attachment;filename=\"filename.xls\"'
    }
    //请求的配置的对象参数
    var axiosObj = {
        method: 'get',
        url: hosturl + url,
        responseType: 'arraybuffer',
        observe: 'response',
        timeout: 30000,
        headers: header,
        params: data
    }

    return axios(axiosObj)
}
export const axiosgetVRXML = function (url, data) { //axios get请求
    var header = {
        'Content-Type': 'application/json;charset=UTF-8',
    }
    //请求的配置的对象参数
    var axiosObj = {
        method: 'get',
        url: previewVrUrl + url,
        headers: header,
        params: data
    }

    return axios(axiosObj)
}
// export const axiospost = function(url, data) { //post请求
//     var header = {
//             'Content-Type': 'application/json;charset=UTF-8',
//             'X-Access-Token': sessionStorage.token ? sessionStorage.token : ''
//         }
//         //请求的配置的对象参数
//     var axiosObj = {
//         method: 'post',
//         url: hosturl + url,
//         timeout: 30000,
//         headers: header,
//         data: data
//     }
//     return axios(axiosObj)
// }

export const axiospost = function (url, data) { //post请求
    var header = {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Access-Token': sessionStorage.token ? sessionStorage.token : ''
    }
    //请求的配置的对象参数
    var axiosObj = {
        method: 'post',
        url: hosturl + url,
        timeout: 30000,
        headers: header,
        data: data || {}
    }
    return axios(axiosObj)
}
// 获取当前会员卡可升级等级列表 post接口使用params(query)传参
export const axiosposts = function (url, data) { //post请求
    var header = {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Access-Token': sessionStorage.token ? sessionStorage.token : ''
    }
    //请求的配置的对象参数
    var axiosObj = {
        method: 'post',
        url: hosturl + url,
        timeout: 30000,
        headers: header,
        params: data || {}
    }
    return axios(axiosObj)
}
export const axiosdelete = function (url, data) { //post请求
    var header = {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Access-Token': sessionStorage.token ? sessionStorage.token : ''
    }
    //请求的配置的对象参数
    var axiosObj = {
        method: 'delete',
        url: hosturl + url,
        timeout: 30000,
        headers: header,
        params: data
    }

    return axios(axiosObj)
}

function axiosformpost(url, data, url1) { //post 模拟form提交请求（上传图片）
    var header = {
        'Content-Type': 'multipart/form-data',
        'X-Access-Token': sessionStorage.token ? sessionStorage.token : ''
    }
    //请求的配置的对象参数
    var axiosObj = {
        method: 'post',
        url: url1 ? url1 : hosturl + url,
        timeout: 30000,
        headers: header,
        data: data
    }
    return axios(axiosObj)
}

function axiosformpostAR(url, data) {
    var header = {
        'Content-Type': 'multipart/form-data',
        'X-Access-Token': sessionStorage.token ? sessionStorage.token : ''
    }
    //请求的配置的对象参数
    var axiosObj = {
        method: 'post',
        url: url,
        headers: header,
        data: data
    }
    return axios(axiosObj)
}
//登陆
export const Login = (username, password, yptoken, ypauthenticate) => axiospost('/sys/login', {
    username: username,
    password: password,
    yptoken: yptoken,
    ypauthenticate: ypauthenticate
})
//通过id获取菜单详情
export const getmenuinfo = (permissionId) => axiosget('/sys/permission/queryById', {
    permissionId: permissionId
});
//修改菜单详情
export const editmenu = (upobj) => axiospost('/sys/permission/edit', upobj);
// 获取菜单
export const getmenu = () => axiosget('/sys/permission/getUserPermissionByToken', {});
// 菜单列表
export const menulist = () => axiosget('/sys/permission/list', {});
// 删除菜单
export const deletmenu = (id) => axiospost('/sys/permission/delete', {
    id: id
});
//创建菜单
export const creatmenu = (upobj) => axiospost('/sys/permission/add', upobj);

export const createCompanyAccess = (name, registration_number, legal_person, legal_card, open_startdate, open_enddate, open_type, business_license, cardimg, authimg, abbreviation, company_type) => axiospost('/sys/tdeconomiccompany/add', {
    name: name,
    registration_number: registration_number,
    legal_person: legal_person,
    legal_card: legal_card,
    open_startdate: open_startdate,
    open_enddate: open_enddate,
    open_type: open_type,
    business_license: business_license,
    cardimg: cardimg,
    authimg: authimg,
    abbreviation: abbreviation,
    company_type: company_type
})

// export const upimg = (params)  => axiosformpost('/upload/uploadList',params,'http://yjtest.cindata.cn/gxdyj/upload/uploadList')
export const upimg = (params) => axiosformpost('/public/uploadList', params)

export const uploadARimg = (url, params) => axiosformpostAR(url, params)
export const getDistrictList = () => axiosget('/guest/area/getDistrictList', {
    cityId: '2301'

})